import React, { useEffect, useMemo } from 'react'
import _ from 'lodash'
import { Editor, EditorContent, useEditor } from '@tiptap/react'
import clsx from 'clsx'
import { getEditorExtensions } from '../../richtext'
import { expandEmptyParagraphMarkers } from '../../../../../utils/multilineText'
import { MarkdownType } from '../../multiline-text/MultilineTextEditor/types'
import './styles.scss'

type Props = {
  text: string
  markdownType?: MarkdownType
}

export const MarkdownPreview = ({ text, markdownType }: Props) => {
  const editor = useEditor({
    extensions: getEditorExtensions(),
    editable: false,
    content: '',
    parseOptions: {
      preserveWhitespace: 'full',
    },
    editorProps: {
      attributes: {
        class: clsx('richtext-editor', {
          'markdown-side-by-side': markdownType === MarkdownType.SideBySide,
        }),
      },
    },
  })

  const debouncedSetContent = useMemo(
    () =>
      _.debounce((ed: Editor, md: string) => {
        ed.commands.setContent(expandEmptyParagraphMarkers(md || ''), {
          contentType: 'markdown',
          emitUpdate: false,
        })
      }, 200),
    []
  )

  useEffect(() => {
    if (!editor) return
    debouncedSetContent(editor, text)
    return () => debouncedSetContent.cancel()
  }, [editor, text, debouncedSetContent])

  return <EditorContent editor={editor} />
}
